import { useScrollToHash } from "../../hooks/useScrollToHash";

// Resets scroll position on every route change (or scrolls to a #hash target
// when present). Mounted once inside the router so every page gets this for free.
export function ScrollToTop() {
  useScrollToHash();
  return null;
}
